import { Component, OnInit } from '@angular/core';
import {IbRequest} from '../ib-request';
import {IbResponse} from '../ib-response';
import { CallBackEndService } from '../call-back-end.service';
declare var getHexAscii: any;

import 'rxjs/Rx';
@Component({
  selector: 'app-update-mobile',
  templateUrl: './update-mobile.component.html',
  styleUrls: ['./update-mobile.component.css']
})
export class UpdateMobileComponent implements OnInit {
storedOtp : string ='';
  isShow : string='';
  error : string='';
  invalidOtp : string='';
  otp : string ='';
  invalidnewMobile ='';
  newMobile : string ='';
  newMobileConfirm : string ='';
  invalidOtpNew : string ='';
  Newotp : string ='';
  storedNewOtp : string='';
  emailId : string;
  successResponse : string ;
  isDisabled : boolean = false;
  disabledafterotp: boolean;
  disablesubBtn:boolean=false;
  isDisable : boolean=false;
  otpBlank : string='';
  newMobileBlank : string='';
  invalidLength : string ='';
  characterInsert : string ='';
  specialcharacterInsert : string ='';
  speceInsert : string='';
  confirmnewMobileBlank : string ='';
  notBothSame : string ='';
 
newOtpBlank='';
  otpError: string;

  regNumsOnly =/^\d+$/;
  confirmMobileError: string;


  constructor(private webService: CallBackEndService) {
     
     this.isDisabled = true;
    const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      //this.isLoad = true;
      request.param1 = getHexAscii('',sessionStorage.getItem('storedUserName'));
      request.param2 =sessionStorage.getItem('storedUserName');
      this.webService.getResponse(request, 'generateOtp').subscribe((data: IbResponse) => {
        response = data;
        //this.isLoad = false;
        if (response !== null && response.status === 'S200') {
          // console.log("otp iss "+response.param1);
          // this.storedOtp=response.param1;
          this.isShow='page1';
        } else if (response !== null) {
          this.isShow='page4';
          this.error = response.param1;
        } else {
          this.isShow='page4';
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
  }
submotOTP()
  {
    if(this.validateOtp()) {
   
     const request: IbRequest = new IbRequest();
     let response: IbResponse = null;
     request.param1 = getHexAscii("",sessionStorage.getItem('storedUserName') + this.otp) ;
    
     
     var otpDetails = {
        'userName':sessionStorage.getItem('storedUserName'),
        'otp': getHexAscii('',this.otp)
      };
      
       request.param6 = otpDetails;
      this.webService.getResponse(request, 'validateOTP').subscribe((data: IbResponse) => {
        response = data;
        //this.isLoad = false;

        if (response !== null && response.status === 'S200') {
          this.isShow='page2';
        }
        else if(response !== null )
        { 
          this.otpError='backendError';
          this.error=response.param1;
        }
        else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });

}
  }
  submitNewMobile() {

    // if (this.newMobile === '' || this.newMobile === ' ' || this.newMobile === undefined) {
    //   this.newMobileBlank = 'no';
    //   this.isDisable = true;
    // } else if (this.newMobileConfirm === '' || this.newMobileConfirm === ' ' || this.newMobileConfirm === undefined) {
    //   this.confirmnewMobileBlank = 'no';
    //   this.isDisable = true;
    // }else if(this.Newotp===''||this.Newotp==='  '||this.Newotp===undefined)
    // {
    //   this.newOtpBlank='no';
    //    this.isDisable = true;
    // } 
    if(this.getQuickOTPValid()) {
      this.disablesubBtn = true;
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      var otpDetails = {
        'userName':sessionStorage.getItem('storedUserName'),
        'otp': getHexAscii('',this.Newotp)
      };
      this.disablesubBtn = true;

      request.param1 = getHexAscii("",sessionStorage.getItem('custNo') + this.newMobile +sessionStorage.getItem('storedUserName')+this.Newotp),
        request.param2 =sessionStorage.getItem('custNo');
      request.param3 = this.newMobile;
      request.param4 = "";
      request.param5 = "";
      request.param6 = otpDetails;
      this.webService.getResponse(request, 'updateMobileNoOrEmailId').subscribe((data: IbResponse) => {
        response = data;
        //this.isLoad = false;

        if (response !== null && response.status === 'S200') {
          this.isShow='page4';
          this.successResponse=response.param1;
        }
        else if(response !== null && response.status === 'OBJECT_NOT_FOUND')
        { 
          this.isShow='page4';
          this.successResponse=response.param1;
        }
         else if(response !== null )
        { 
          this.error=response.param1;
        }
        else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });

  }
  }
  submotNewOTP() {
    if (this.newMobile === '' || this.newMobile === ' ' || this.newMobile === undefined) {
      this.newMobileBlank = 'no';
      this.isDisable = true;
    } else if (this.newMobileConfirm === '' || this.newMobileConfirm === ' ' || this.newMobileConfirm === undefined) {
      this.confirmnewMobileBlank = 'no';
      this.isDisable = true;
    } else {
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      //this.isLoad = true;
      request.param1 = getHexAscii('',sessionStorage.getItem('storedUserName') + this.newMobile);
      request.param2 =sessionStorage.getItem('storedUserName');
      request.param3 = this.newMobile;     
      this.webService.getResponse(request, 'generateOtpForNewMob').subscribe((data: IbResponse) => {
        response = data;
        this.confirmMobileError = '';
        this.error = '';
        //this.isLoad = false;
        if (response !== null && response.status === 'S200') {
          // this.storedNewOtp = response.param1;
          // console.log('New otp ' + response.param1);
          this.isShow = 'page3';
          
        } else if (response !== null) {
          this.confirmMobileError = 'fromBackend';
          this.error = response.param1===undefined ? "No Error Message from server" : response.param1;
        } else {
          
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  }
  // getQuickOTPValid() {
  //   if (this.Newotp === undefined || this.Newotp === '') {
  //     this.invalidOtp = 'no';
  //     this.disabledafterotp = true;
  //   }
  // }

  getQuickOTPValid(){
    if(this.Newotp==='' || this.Newotp===' ' || this.Newotp===null || this.Newotp===undefined ){
      this.newOtpBlank = 'no';
      // this.disabledafterotp = true;
      return false;
    }else if(!this.Newotp.match(this.regNumsOnly)){
      this.newOtpBlank = 'nums';
      // this.disabledafterotp = true;
      return false;
    }else{
      this.newOtpBlank = '';
      return true;
    }
    
  }



  getQuickmesageOTPRemove() {
    this.invalidOtp = '';
    this.disabledafterotp = false;
    this.error='';
    this.newOtpBlank='';
  }

  validateOtp(){
    if(this.otp==='' || this.otp===' ' || this.otp===null || this.otp===undefined ){
      this.otpError='yes';
      return false;
    }else if(!this.otp.match(this.regNumsOnly)){
      this.otpError='nums';
      return false;
    }
    return true;
  }

  ngOnInit() {
   
  }

  removeMessagesOTP()
  {
    this.otpBlank='';
    this.invalidOtp='';
    this.error='';
    this.otpError='';
  }

  newmobileValidate()
  {

    this.isDisable = true;
    var regchar = '/^[A-Za-z]+$/';
    var reg=new RegExp(/[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g);
    var numbers = new RegExp(/^[0-9]+$/);
    var regexpspace=new RegExp("\\s");
    var code = this.newMobile;
    var isnumber=numbers.test(code);
    if(this.newMobile===''|| this.newMobile===' '|| this.newMobile===undefined)
    {
  this.newMobileBlank='no';
  this.confirmnewMobileBlank='';
  this.notBothSame='';
      this.isDisable = true;
    }
    else if(/^[a-zA-Z]/i.test(this.newMobile))
    {
      this.characterInsert='no';
      this.isDisable = true;
      this.confirmnewMobileBlank='';
      this.notBothSame='';
    }
    else if(this.newMobile.match(reg))
    {
      this.specialcharacterInsert='no';
      this.isDisable = true;
      this.confirmnewMobileBlank='';
       this.notBothSame='';
    }
    else if(this.newMobile.match(regexpspace))
    {
      this.speceInsert='no';
      this.isDisable = true;
      this.confirmnewMobileBlank='';
      this.notBothSame='';
    }
    else if(this.newMobile.length<10)
    {
      this.invalidLength='no';
      this.isDisable = true;
      this.confirmnewMobileBlank='';
      this.notBothSame='';
    }else if(this.newMobileConfirm!=null && !this.newMobile.match(this.newMobileConfirm)){
      this.notBothSame='no';
      this.isDisable = true;
    }else{
      this.invalidLength='';
      this.isDisable = false;
      this.confirmnewMobileBlank='';
      this.notBothSame='';
    }

  }
  removeMessagesnewMobile()
  {
    this.newMobileBlank='';
    this.invalidLength='';
    this.speceInsert='';
    this.specialcharacterInsert='';
    this.characterInsert='';
    this.confirmMobileError = '';
    this.isDisable = false;
  }
  confirmmobileValidate()
  {
    this.isDisable = false;
    if(this.newMobileConfirm===''|| this.newMobileConfirm===' '|| this.newMobileConfirm===undefined)
    {
      this.confirmnewMobileBlank='no';
      this.isDisable = true;
    }
    else if(this.newMobile!==this.newMobileConfirm)
    {
      this.notBothSame='no';
      this.isDisable = true;
    }
  }
  confirmMessagesnewMobile()
  {
    this.confirmnewMobileBlank='';
    this.notBothSame='';
    this.confirmMobileError = '';
    this.isDisable = false;
}
  ok()
  {
    this.isShow='page1';
    this.newMobile='';
    this.newMobileConfirm='';
    this.otp='';
    this.Newotp='';
  }
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/update-mobile/update-mobile.component.ts